const MAX_RETRIES = 2

export const withinRetryBudget = failureCount => failureCount < MAX_RETRIES

// A request with no response (a dropped connection) or a 5xx may succeed if repeated; a 4xx will not.
export const isTransientHttpError = error => {
  const status = error?.response?.status
  return status == null || status >= 500
}

export const retryTransient = (failureCount, error) => isTransientHttpError(error) && withinRetryBudget(failureCount)
